import { render } from "./ProprietaireForgetPassword.vue?vue&type=template&id=bc170b3e&scoped=true"
import script from "./ProprietaireForgetPassword.vue?vue&type=script&lang=js"
export * from "./ProprietaireForgetPassword.vue?vue&type=script&lang=js"

import "./ProprietaireForgetPassword.vue?vue&type=style&index=0&id=bc170b3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc170b3e"]])

export default __exports__